import { render, staticRenderFns } from "./surface_post_reaction.vue?vue&type=template&id=35a0438f&"
import script from "./surface_post_reaction.vue?vue&type=script&lang=ts&"
export * from "./surface_post_reaction.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_reaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports